"use client";
import * as React from "react";
const SvgFavoriteBorderSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M11.6.5c-1.392 0-2.728.662-3.6 1.708C7.128 1.162 5.792.5 4.4.5 1.936.5 0 2.478 0 4.996c0 3.09 2.72 5.607 6.84 9.433L8 15.5l1.16-1.079C13.28 10.604 16 8.086 16 4.996 16 2.478 14.064.5 11.6.5ZM8.08 13.211l-.08.082-.08-.082C4.112 9.688 1.6 7.358 1.6 4.996c0-1.635 1.2-2.861 2.8-2.861 1.232 0 2.432.81 2.856 1.929h1.496c.416-1.12 1.616-1.93 2.848-1.93 1.6 0 2.8 1.227 2.8 2.862 0 2.362-2.512 4.692-6.32 8.215Z" }));
export {
  SvgFavoriteBorderSharp as default
};
